import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LoginPage } from '@/pages/auth';
import { ProtectedRoute } from './ProtectedRoute';
import { RootRedirect } from './RootRedirect';
import { MainLayout } from '@/layouts/MainLayout';
import { POSPage } from '@/pages/pos';
import { InventoryPage } from '@/pages/inventory';
import { InventoryAuditDetailPage } from '@/pages/inventory/InventoryAuditDetailPage';
import { IngredientsPage } from '@/pages/inventory/IngredientsPage';
import { PurchaseOrdersPage } from '@/pages/inventory/components/PurchaseOrdersPage';
import { PurchaseOrderCreatePage } from '@/pages/inventory/components/PurchaseOrderCreatePage';
import { PurchaseOrderDetailPage } from '@/pages/inventory/components/PurchaseOrderDetailPage';
import { PurchaseOrderReceivePage } from '@/pages/inventory/components/PurchaseOrderReceivePage';
import { CashRegisterPage } from '@/pages/cash-register';
import { ProductsPage } from '@/pages/products';
import { ReportsPage } from '@/pages/reports';
import { CustomersPage } from '@/pages/customers';
import { PromotionsPage } from '@/pages/promotions';
import { CreatePromotionPage } from '@/pages/promotions/CreatePromotionPage';
import { EditPromotionPage } from '@/pages/promotions/EditPromotionPage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
import { TablesPage } from '@/pages/tables';
import { EmployeesPage } from '@/pages/employees';
import { DistributionPage } from '@/pages/distribution/DistributionPage';
import { TransferDetailPage } from '@/pages/distribution/components/TransferDetailPage';
import { LocationsPage } from '@/pages/locations';
import { KardexPage } from '@/pages/kardex';
import { TransformationOrdersPage } from '@/pages/transformations/TransformationOrdersPage';
import { CreateTransformationPage } from '@/pages/transformations/CreateTransformationPage';
import { SuppliersPage } from '@/pages/suppliers/SuppliersPage';
import { VoucherManagementPage } from '@/pages/vouchers';
import { AccountsPayablePage } from '@/pages/accounts-payable';
import { AccountPayableDetailPage } from '@/pages/accounts-payable/AccountPayableDetailPage';
import { MerchandiseMovementsPage } from '@/pages/merchandise-movements/MerchandiseMovementsPage';
import { StockConfigPage } from '@/pages/stock-config';
import { SystemParametersPage } from '@/pages/system-parameters';
import { BreadTransfersPage } from '@/pages/bread-transfers/BreadTransfersPage';
import { VoidSalesPage } from '@/pages/void-sales/VoidSalesPage';
import { DiscrepancyReviewPage } from '@/pages/discrepancy-review';

export const AppRouter: React.FC = () => {
  return (
    <Routes>
      {/* Redirect raíz condicional */}
      <Route path="/" element={<RootRedirect />} />
      
      {/* Ruta de login (pública) */}
      <Route path="/login" element={<LoginPage />} />
      
      {/* Rutas protegidas individuales */}
      <Route path="/pos" element={
        <ProtectedRoute>
          <MainLayout>
            <POSPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/inventory" element={
        <ProtectedRoute>
          <MainLayout>
            <InventoryPage />
          </MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/inventory/audit/:auditId" element={
        <ProtectedRoute>
          <MainLayout>
            <InventoryAuditDetailPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/ingredients" element={
        <ProtectedRoute>
          <MainLayout>
            <IngredientsPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/purchase-orders" element={
        <ProtectedRoute>
          <MainLayout>
            <PurchaseOrdersPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/purchase-orders/new" element={
        <ProtectedRoute>
          <MainLayout>
            <PurchaseOrderCreatePage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/purchase-orders/:orderId" element={
        <ProtectedRoute>
          <MainLayout>
            <PurchaseOrderDetailPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/purchase-orders/:orderId/receive" element={
        <ProtectedRoute>
          <MainLayout>
            <PurchaseOrderReceivePage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      
      <Route path="/cash-register" element={
        <ProtectedRoute>
          <MainLayout>
            <CashRegisterPage />
          </MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/void-sales" element={
        <ProtectedRoute>
          <MainLayout>
            <VoidSalesPage />
          </MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/products" element={
        <ProtectedRoute>
          <MainLayout>
            <ProductsPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/reports" element={
        <ProtectedRoute>
          <MainLayout>
            <ReportsPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/customers" element={
        <ProtectedRoute>
          <MainLayout>
            <CustomersPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/promotions" element={
        <ProtectedRoute>
          <MainLayout>
            <PromotionsPage />
          </MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/promotions/new" element={
        <ProtectedRoute>
          <MainLayout>
            <CreatePromotionPage />
          </MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/promotions/edit/:id" element={
        <ProtectedRoute>
          <MainLayout>
            <EditPromotionPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <MainLayout>
            <DashboardPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/tables" element={
        <ProtectedRoute>
          <MainLayout>
            <TablesPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/employees" element={
        <ProtectedRoute>
          <MainLayout>
            <EmployeesPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/distribution" element={
        <ProtectedRoute>
          <MainLayout>
            <DistributionPage />
          </MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/distribution/transfers/:id" element={
        <ProtectedRoute>
          <MainLayout>
            <TransferDetailPage />
          </MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/locations" element={
        <ProtectedRoute>
          <MainLayout>
            <LocationsPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/kardex" element={
        <ProtectedRoute>
          <MainLayout>
            <KardexPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/transformations" element={
        <ProtectedRoute>
          <MainLayout>
            <TransformationOrdersPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/transformations/create" element={
        <ProtectedRoute>
          <MainLayout>
            <CreateTransformationPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/suppliers" element={
        <ProtectedRoute>
          <MainLayout>
            <SuppliersPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/vouchers/manage" element={
        <ProtectedRoute>
          <MainLayout>
            <VoucherManagementPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/accounts-payable" element={
        <ProtectedRoute>
          <MainLayout>
            <AccountsPayablePage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/accounts-payable/:accountId" element={
        <ProtectedRoute>
          <MainLayout>
            <AccountPayableDetailPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/merchandise-movements" element={
        <ProtectedRoute>
          <MainLayout>
            <MerchandiseMovementsPage />
          </MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/discrepancy-review" element={
        <ProtectedRoute>
          <MainLayout>
            <DiscrepancyReviewPage />
          </MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/stock-config" element={
        <ProtectedRoute>
          <MainLayout>
            <StockConfigPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/system-parameters" element={
        <ProtectedRoute>
          <MainLayout>
            <SystemParametersPage />
          </MainLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/bread-transfers" element={
        <ProtectedRoute>
          <MainLayout>
            <BreadTransfersPage />
          </MainLayout>
        </ProtectedRoute>
      } />
    </Routes>
  );
};